export function getConsultorioTabs({ permittedTabs, unitContext, patient, entity }) {
  if (unitContext?.navigationContext === 'hospitalar') return permittedTabs.filter(tab => tab.key === 'pacientes');
  const receptionOnly = unitContext?.selected && !unitContext.selected.is_primary && !unitContext.clinicalReady;
  const ongoing = patient?.agendamento_status === 'Em andamento';
  const clinical = ['prontuario', 'historico', 'anamnese', 'laudo', 'relatorio', 'exames', 'pedidos', 'atestado', 'conferencia'];
  const tabs = permittedTabs.filter(tab => {
    if (receptionOnly && !['agenda', 'pacientes'].includes(tab.key)) return false;
    if (['agenda', 'pacientes'].includes(tab.key)) return !patient;
    return clinical.includes(tab.key) && ongoing;
  });
  const modules = entity?.modulos_ativos;
  if (!receptionOnly && (!Array.isArray(modules) || modules.includes('odontologia')) && entity?.odontologia_habilitada && ongoing) {
    tabs.push({ key: 'odontologia', title: 'Odontologia' });
  }
  return tabs;
}
